import { render } from "./CaseVerificationCard.vue?vue&type=template&id=8e4c1b2c"
import script from "./CaseVerificationCard.vue?vue&type=script&lang=js"
export * from "./CaseVerificationCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__